import React, { Suspense } from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import store from './app/store';
import { Provider } from 'react-redux';
import SuspenseContent from './containers/SuspenseContent';
import { loadConfig } from './config';
import initializeApp from './app/init';

const root = ReactDOM.createRoot(document.getElementById('root'));

// Ensure config loads before initializing and rendering React
loadConfig().then(() => {
  initializeApp();
  root.render(
    // <React.StrictMode>
    <Suspense fallback={<SuspenseContent />}>
      <Provider store={store}>
        <App />
      </Provider>
    </Suspense>
    // </React.StrictMode>
  );
});

reportWebVitals();
